import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as selectors from "../selectors";
import { Button, Col, message, Modal, notification, Row, Select } from "antd";
import { IoCloseSharp } from "react-icons/io5";
import Title from "antd/lib/typography/Title";
import Text from "antd/lib/typography/Text";
import { actions } from "../slice";

const getProjectFilters = (projects) => {
  const filter = projects?.map((entity) => ({
    label: entity.projectCode,
    value: entity._id,
  }));
  return filter?.length ? filter : [];
};

function EditProjectCode({ isOpen, onClose, KitDetail, fetchKitDetail }) {
  const dispatch = useDispatch();
  const projects = useSelector(selectors.selectProjects);
  const [selectedProject, setSelectedProject] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const handleEdit = () => {
    if (selectedProject === KitDetail?.projectCode?._id) {
      message.warning("No changes made to the project code.");
      return;
    }

    const data = [
      {
        samplerKitId: KitDetail._id,
        projectCodeId: selectedProject,
      },
    ];
    setIsLoading(true);
    dispatch(
      actions.updateProjectCode({
        data,
        onSuccess: () => {
          notification.success({
            message: "Project code updated successfully",
          });
          setIsLoading(false);
          handleCancel();
          fetchKitDetail();
        },
        onFailure: (error) => {
          setIsLoading(false);
          notification.error({
            message: "Failed to update project code",
            description: error.message,
          });
        },
      })
    );
  };

  const handleCancel = () => {
    onClose();
    setSelectedProject(null);
  };

  useEffect(() => {
    if (KitDetail?.projectCode?._id) {
      setSelectedProject(KitDetail.projectCode._id);
    }
  }, [isOpen]);

  return (
    <>
      <Modal
        visible={isOpen}
        onCancel={handleCancel}
        footer={[
          <Button key="cancle" onClick={handleCancel}>
            Cancel
          </Button>,
          <Button
            key="handleEdit"
            type="primary"
            loading={isLoading}
            onClick={handleEdit}
          >
            Edit Project Code
          </Button>,
        ]}
        bodyStyle={{ borderRadius: 16, padding: 24, background: "#fff" }}
        style={{ borderRadius: 16 }}
        closeIcon={<IoCloseSharp size="24" />}
        centered
        className="modal-content"
      >
        <Title level={3} style={{ fontWeight: 800, marginBottom: 15 }}>
          Edit Project Code
        </Title>
        <Row style={{ margin: "20px 0px" }}>
          <Col span={24}>
            <Text style={{ fontWeight: 600, color: "#232A36" }}>
              Project Code
            </Text>
            <Select
              showSearch
              optionFilterProp="label"
              placeholder="Select Project"
              options={getProjectFilters(projects)}
              value={selectedProject}
              onChange={(value) => setSelectedProject(value)}
              className="filter-select"
              style={{
                width: "100%",
                marginTop: 6,
              }}
              size="large"
            />
          </Col>
        </Row>
      </Modal>
    </>
  );
}

export default EditProjectCode;
